import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PreviewModalComponent } from './preview-modal';

export const PreviewModalModule: string = ng
    .module('preview-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('previewModalComponent', PreviewModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/preview-modal/preview-modal.module.ts